<template>
  <div :class="[_isMobile() ? 'mobile' : '']">
    <a-card :bordered="false">
      <a-row type="flex" justify="space-around">
        <a-col :xs="24" :sm="24" :md="13" :lg="10" :xl="10">
          <div class="login-wrap">
            <Login />
          </div>
        </a-col>
        <a-col
          :xs="0"
          :sm="0"
          :md="10"
          :lg="13"
          :xl="13"
          v-if="$store.state.user.tenantInfo.loginBg"
        >
          <img
            style="width: 100%"
            class="cover"
            v-if="$store.state.user.tenantInfo.loginBg"
            :src="$store.state.user.tenantInfo.loginBg"
            alt=""
          />
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { TENANT_CONFIG } from "@/store/mutation-types";
import Login from "../components/user/Login";
import { mixinDevice } from "@/utils/mixin.js";

export default {
  mixins: [mixinDevice],
  components: {
    Login,
  },
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.mobile {
  .login-wrap {
    padding: 0 !important;
  }
}
.login-wrap {
  padding: 40px 40px;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000039;
}
</style>